import { defineComponent as _defineComponent } from 'vue'
import { size } from 'underscore';
import {
  computed, onMounted, ref, watch,
} from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import ApiBanner from '@/components/promotion/ApiBanner.vue';
import DirtyModalLieferando from '@/components/promotion/DirtyModalLieferando.vue';
import DirtyModalZalando from '@/components/promotion/DirtyModalZalando.vue';
import MskModal from '@/components/promotion/MskModal.vue';
import ShopWall from '@/components/redeem/shop-wall/ShopWall.vue';
import VoucherInfoModal from '@/components/redeem/VoucherInfoModal.vue';
import RegionMapText from '@/components/RegionMapText.vue';
import flashMessage from '@/plugins/flash-message/flash-message';
import { t } from '~i18n';
import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopListPage',
  props: {
  /* The id for the current shop like "1524" or "5521" */
  id: {
    type: String,
    default: null,
  },
  /* The slug in the url for the current shop like "h-und-m" or "amazon" */
  slug: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const route = useRoute();
const router = useRouter();
const getters = store?.getters;



const showShopModal = ref(route?.meta?.showShopModal);
const maxChargeValue = ref(35_00);// 35 EUR

const dirtyShopSlugLieferando = ref(/^(L|l)ieferando.*/);// URL slug of the DirtyModal Shop like "QuirionDE" /^(Q|q)uirion.*/
const dirtyRequiredValueLieferando = ref(50_00);

const category = computed(() => getters.getCategory);
const showVoucherInfoModal = computed(() => getters.getShowVoucherInfoModal);
const showMskPromo = computed(() => getters.getShowMskPromo);
const voucher = computed(() => getters.getVoucher);
const country = computed(() => getters.getCountry);
const shopWall = computed(() => getters.getShopWall);
const voucherTokenPayload = computed(() => getters.getVoucherTokenPayload);
const voucherBalanceInCent = computed(() => getters.getVoucherBalanceInCent);
const configId = computed(() => getters.getConfigId);

/*
 * Shows the Dirty Modal on special conditions.
 */
const dirtyModalLieferandoActive = computed((): boolean => {
  const hasCategory = !category.value;
  const showForSites = (
    sites: string[],
  ) => sites.includes(configId.value);
  const showForCountries = (
    countries: string[],
  ) => countries.includes(country.value?.toLocaleLowerCase());
  const shopWallContainsDirtySlug =
    !dirtyShopSlugLieferando.value || shopWall.value?.some?.((shop) => dirtyShopSlugLieferando.value.test(shop.slug));
  const noThirdPartyRedeem = !('thirdPartyRedeem' in voucherTokenPayload.value);
  const canBeCharged = dirtyRequiredValueLieferando.value - voucherBalanceInCent.value <= maxChargeValue.value;
  const inDateRange = new Date('2025-05-01') <= new Date() && new Date('2025-05-31 23:59:59') >= new Date();

  return (
    hasCategory &&
    showForCountries(['de']) &&
    showForSites(['wunschgutschein-de']) &&
    shopWallContainsDirtySlug &&
    noThirdPartyRedeem &&
    canBeCharged &&
    inDateRange
  );
});

const dirtyShopSlugZalando = ref(/^(Z|z)alando.*/);
const dirtyRequiredValueZalando = ref(50_00);

const dirtyModalZalandoActive = computed((): boolean => {
  const hasCategory = !category.value;
  const showForSites = (
    sites: string[],
  ) => sites.includes(configId.value);
  const showForCountries = (
    countries: string[],
  ) => countries.includes(country.value?.toLocaleLowerCase());
  const shopWallContainsDirtySlug =
    !dirtyShopSlugZalando.value || shopWall.value?.some?.((shop) => dirtyShopSlugZalando.value.test(shop.slug));
  const noThirdPartyRedeem = !('thirdPartyRedeem' in voucherTokenPayload.value);
  const canBeCharged = dirtyRequiredValueZalando.value - voucherBalanceInCent.value <= maxChargeValue.value;
  const inDateRange = new Date('2025-05-01') <= new Date() && new Date('2025-05-31 23:59:59') >= new Date();

  return (
    hasCategory &&
    showForCountries(['ch']) &&
    showForSites(['wishcard-ch']) &&
    shopWallContainsDirtySlug &&
    noThirdPartyRedeem &&
    canBeCharged &&
    inDateRange
  );
});

watch(route, ({ meta }): void => {
  showShopModal.value = meta?.showShopModal;
});

onMounted((): void => {
  // redirect to home if no voucher is set
  if (!size(voucher.value)) {
    router.push({ name: 'redeem' });
  }

  store.dispatch('resetFilters');

  store.dispatch('whenTokenExpires', (): void => {
    flashMessage.add('redeemError', `${t('wgs.std.sessionExpired')} ${t('wgs.redeem.enterCodeAgain')}`);

    const params = {} as {category: string};
    if (category.value !== null) {
      params.category = category.value;
    }
    router.push({ name: 'redeem', params });
  });

  const regionShopId = store?.state?.region?.shopId;
  if (regionShopId) {
    const { href } = router.resolve(
      {
        name: 'shopDetails',
        params: {
          id: String(regionShopId),
        },
      },
    );

    router.push(href);
  }
});

/*
 * Change route if shop details modal was closed
 *
 * Only change if the route isn't already the 'shops'-route
 * => Fixing the duplication navigation error bug (router-history)
 *
 * Prevent scrolling up by setting meta scrollToTop to false
 * => Fixing the scrolling to top bug
 *
 */
function onHideShopDetailsModal(): void {
  const name = 'shops';
  if (route.name !== name) {
    router.push({ name });
    if (route.meta) {
      route.meta.scrollToTop = false;
    }
  }

  store.dispatch('clearShopDetails');
}

return { __sfc: true,route, router, getters, showShopModal, maxChargeValue, dirtyShopSlugLieferando, dirtyRequiredValueLieferando, category, showVoucherInfoModal, showMskPromo, voucher, country, shopWall, voucherTokenPayload, voucherBalanceInCent, configId, dirtyModalLieferandoActive, dirtyShopSlugZalando, dirtyRequiredValueZalando, dirtyModalZalandoActive, onHideShopDetailsModal, ApiBanner, DirtyModalLieferando, DirtyModalZalando, MskModal, ShopWall, VoucherInfoModal, RegionMapText }
}

})